module.exports = __webpack_public_path__ + "img/ALGO_icon.ab167eae.png";